import { render, staticRenderFns } from "./LiveQATextLeftModal.vue?vue&type=template&id=09dd85b6&scoped=true&"
import script from "./LiveQATextLeftModal.vue?vue&type=script&lang=js&"
export * from "./LiveQATextLeftModal.vue?vue&type=script&lang=js&"
import style0 from "./LiveQATextLeftModal.vue?vue&type=style&index=0&id=09dd85b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dd85b6",
  null
  
)

export default component.exports